import { Loader } from '@components/loader';

export const PageLoader = () => (
  <div className="relative h-96">
    <Loader local />
  </div>
);
